import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Phone, Mail, MapPin } from 'lucide-react';

const Footer13 = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');

    const handleSubscribe = (e) => {
        e.preventDefault();
        if (email.trim()) setEmail('');
    };

    const quickLinks = [
        { label: 'Home', path: '/template13' },
        { label: 'Shop', path: '/template13/shop' },
        { label: 'About', path: '/template13/about' },
        { label: 'Contact', path: '/template13/contact' },
        { label: 'Orders', path: '/template13/orders' },
    ];

    const customerCareLinks = [
        { label: 'Shipping & Returns', path: '/template13/shipping-exchange' },
        { label: 'Privacy Policy', path: '/template13/privacy-policy' },
        { label: 'Terms & Conditions', path: '/template13/terms-conditions' },
        { label: 'FAQs', path: '/template13/faqs' },
    ];

    const craftLinks = [
        { label: 'Handloom Sarees', path: '/template13/shop' },
        { label: 'Block Print Kurtas', path: '/template13/shop' },
        { label: 'Ikat Fabrics', path: '/template13/shop' },
        { label: 'Kalamkari', path: '/template13/shop' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@400;700&family=Mulish:wght@300;400;600&display=swap');
                .karigar-footer-grid {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 32px;
                }
                @media (min-width: 768px) {
                    .karigar-footer-grid {
                        grid-template-columns: 1.5fr 1fr 1fr 1fr;
                        gap: 40px;
                    }
                }
            `}</style>

            <footer style={{ backgroundColor: '#C2410C' }}>
                {/* Main Footer */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '56px 20px' }}>
                    <div className="karigar-footer-grid">
                        {/* Brand Column */}
                        <div>
                            <h3 style={{
                                fontFamily: "'Merriweather', Georgia, serif",
                                fontSize: '28px', fontWeight: 700, color: '#FBF8F4',
                                letterSpacing: '2px', margin: '0 0 12px 0',
                                textTransform: 'uppercase',
                            }}>
                                KARIGAR
                            </h3>
                            <p style={{
                                fontFamily: "'Mulish', sans-serif",
                                fontSize: '14px', color: 'rgba(251, 248, 244, 0.75)',
                                lineHeight: 1.7, margin: '0 0 20px 0',
                                fontStyle: 'italic',
                            }}>
                                Crafted By Hand, Worn With Pride
                            </p>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {[Instagram, Facebook].map((Icon, i) => (
                                    <a key={i} href="#" style={{
                                        width: '38px', height: '38px', borderRadius: '50%',
                                        border: '1px solid rgba(251, 248, 244, 0.3)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        color: '#FBF8F4', transition: 'all 0.3s',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#FBF8F4'; e.currentTarget.style.color = '#C2410C'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#FBF8F4'; }}
                                    >
                                        <Icon size={16} />
                                    </a>
                                ))}
                            </div>
                        </div>

                        {/* Our Crafts */}
                        <div>
                            <h4 style={{
                                fontFamily: "'Merriweather', Georgia, serif",
                                fontSize: '15px', fontWeight: 700, color: '#FBF8F4',
                                margin: '0 0 16px 0', letterSpacing: '1px',
                            }}>
                                Our Crafts
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {craftLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Mulish', sans-serif",
                                                fontSize: '13px', color: 'rgba(251, 248, 244, 0.7)',
                                                cursor: 'pointer', transition: 'color 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FBF8F4'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(251, 248, 244, 0.7)'; }}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 style={{
                                fontFamily: "'Merriweather', Georgia, serif",
                                fontSize: '15px', fontWeight: 700, color: '#FBF8F4',
                                margin: '0 0 16px 0', letterSpacing: '1px',
                            }}>
                                Quick Links
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {quickLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Mulish', sans-serif",
                                                fontSize: '13px', color: 'rgba(251, 248, 244, 0.7)',
                                                cursor: 'pointer', transition: 'color 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FBF8F4'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(251, 248, 244, 0.7)'; }}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Customer Care */}
                        <div>
                            <h4 style={{
                                fontFamily: "'Merriweather', Georgia, serif",
                                fontSize: '15px', fontWeight: 700, color: '#FBF8F4',
                                margin: '0 0 16px 0', letterSpacing: '1px',
                            }}>
                                Customer Care
                            </h4>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {customerCareLinks.map((link) => (
                                    <li key={link.label} style={{ marginBottom: '10px' }}>
                                        <span
                                            onClick={() => navigate(link.path)}
                                            style={{
                                                fontFamily: "'Mulish', sans-serif",
                                                fontSize: '13px', color: 'rgba(251, 248, 244, 0.7)',
                                                cursor: 'pointer', transition: 'color 0.3s',
                                            }}
                                            onMouseEnter={(e) => { e.currentTarget.style.color = '#FBF8F4'; }}
                                            onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(251, 248, 244, 0.7)'; }}
                                        >
                                            {link.label}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{
                    borderTop: '1px solid rgba(251, 248, 244, 0.15)',
                    padding: '20px',
                    textAlign: 'center',
                }}>
                    <p style={{
                        fontFamily: "'Mulish', sans-serif",
                        fontSize: '12px', color: 'rgba(251, 248, 244, 0.5)',
                        margin: 0,
                    }}>
                        &copy; 2026 KARIGAR. Preserving Indian Craft Traditions.
                    </p>
                </div>
            </footer>
        </>
    );
};

export default Footer13;
